export default __webpack_public_path__ + "images/lock-hero.c3ce79465f5d0e3b5d89f1f72b5afa44.png";